<div class="border border-gray-200 rounded-lg bg-white p-4 mb-2">
	<canvas
		#canvas
		(pointerdown)="startDrawing()"
		width="600"
		height="200"
		class="aspect-[3/1]"
	></canvas>
	<div class="flex gap-4 justify-between">
		<p class="self-start text-xs">
			NOTE: Your digital signature will only be used within Sync by Closer to be
			applied on applicable mortgage forms.
		</p>
		<div class="flex gap-2">
			<ui-button
				label="Clear"
				[style]="'ghost'"
				(click)="clearPad()"
				[disabled]="signatureImg === ''"
			/>
			<ui-button
				*ngIf="showSaveButton"
				preset="MEDIUM_EMPHASIS"
				label="Save Signature"
				(click)="save()"
				[disabled]="signatureImg === ''"
			/>
		</div>
	</div>
</div>
